import { render, staticRenderFns } from "./GeneradorMasDatosPantalla.vue?vue&type=template&id=1eb44406&scoped=true"
import script from "./GeneradorMasDatosPantalla.vue?vue&type=script&lang=js"
export * from "./GeneradorMasDatosPantalla.vue?vue&type=script&lang=js"
import style0 from "./GeneradorMasDatosPantalla.vue?vue&type=style&index=0&id=1eb44406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb44406",
  null
  
)

export default component.exports